//
//
//
//
//
//

import HelpCreateGenerativeNft from '~/components/HelpCreateGenerativeNft.vue'
export default {
  name: 'Artists',
  components: {
    HelpCreateGenerativeNft,
  },
  mounted() {},
}
